import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { faPenToSquare } from "@fortawesome/free-solid-svg-icons";
import { Icon } from "@sequentech/ui-essentials";
import { translate } from "@sequentech/ui-core";
import { useTranslation } from "react-i18next";
import { Link as RouterLink } from "react-router-dom";
export var ReviewContestFooter = function (_a) {
    var _b;
    var contest = _a.contest, count = _a.count, to = _a.to;
    var _c = useTranslation(), t = _c.t, i18n = _c.i18n;
    var state = { editContestId: contest.id };
    return (_jsxs(Box, { className: "review-contest-footer", sx: {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            flexWrap: "wrap",
            gap: "8px",
            margin: "12px 0",
        }, children: [_jsx(Typography, { className: "review-contest-count", variant: "body2", sx: { margin: 0 }, children: t("slates.review.contestCount", { selected: count.selected, max: count.max }) }), _jsxs(Button, { className: "review-contest-edit", component: RouterLink, to: to, state: state, variant: "secondary", sx: { minHeight: "44px" }, "aria-label": t("slates.review.editLabel", {
                    contest: (_b = translate(contest, "name", i18n.language)) !== null && _b !== void 0 ? _b : "",
                }), children: [_jsx(Icon, { className: "review-contest-edit-icon", icon: faPenToSquare, size: "sm" }), _jsx(Box, { className: "review-contest-edit-label", component: "span", sx: { paddingInlineStart: "8px" }, children: t("slates.review.edit") })] })] }));
};
